import clsx from "classnames";
import { Stack } from "react-bootstrap";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import Email from "@/assets/Email.svg";
import LinkedIn from "@/assets/LinkedIn.svg";
import Twitter from "@/assets/Twitter.svg";
import Facebook from "@/assets/Facebook.svg";
import WhatsApp from "@/assets/WhatsApp.svg";
import NoSSR from "@/ui/NoSSR";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";

export default function SocialShare({ className }) {
  const locale = useLocale();

  return (
    <Stack className={clsx(className, "flex-grow-0")} gap={1}>
      <DynamicText path={`share.label.${locale}`} className="fw-semibold" />
      <Stack className="flex-row" gap={3}>
        <NoSSR>
          {() => (
            <>
              <LinkedinShareButton url={window.location.href} aria-label="LinkedIn">
                <LinkedIn width={15} height={15} />
              </LinkedinShareButton>
              <FacebookShareButton url={window.location.href} aria-label="Facebook">
                <Facebook width={15} height={15} />
              </FacebookShareButton>
              <TwitterShareButton url={window.location.href} aria-label="Twitter">
                <Twitter width={15} height={15} />
              </TwitterShareButton>
              <WhatsappShareButton url={window.location.href} aria-label="WhatsApp">
                <WhatsApp width={15} height={15} />
              </WhatsappShareButton>
              <EmailShareButton url={window.location.href} aria-label="Email">
                <Email width={15} height={15} />
              </EmailShareButton>
            </>
          )}
        </NoSSR>
      </Stack>
    </Stack>
  );
}

SocialShare.defaultProps = {
  className: "",
  title: "Share this",
};
